import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/miro.vue
var o = {
	name: "DtIconMiro",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--miro"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Miro",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M18.774 2H5.226A3.226 3.226 0 0 0 2 5.226v13.548A3.226 3.226 0 0 0 5.226 22h13.548A3.226 3.226 0 0 0 22 18.774V5.226A3.226 3.226 0 0 0 18.774 2Z",
		fill: "#FFD02F"
	}, null, -1), r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M15.506 5.125h-1.951l1.626 2.946-3.577-2.946H9.652l1.789 3.601-3.74-3.601H5.75l1.951 4.583-1.951 9.167h1.951l3.74-9.821-1.789 9.821h1.952L15.18 8.399l-1.626 10.476h1.951l3.577-11.458-3.577-2.292Z",
		fill: "#050038"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=miro.js.map